<template lang="pug">
.container-perfil(:class="{ 'modal-open': feedbackModalVisible }")
  .header
    .info-desenvolvedor
      .pessoa
        .foto-perfil
          img(:src="fotoPerfil" alt="Foto do Desenvolvedor")
        .info
          .nome
            span {{ nomeUsuario }}
            .editar-perfil(@click="$router.push('/espaco-nexa/editar-perfil/informacoes-pessoais')")
              LucideIcon(name="Pencil" :size="20")
          .usuario
            LucideIcon(name="AtSign" :size="16")
            | {{ usuarioApelido }}
          .funcao(v-if="funcaoUsuario")
            LucideIcon(name="Briefcase" :size="16")
            | {{ funcaoUsuario }}
          .localizacao(v-if="localizacaoUsuario")
            LucideIcon(name="MapPin" :size="16")
            | {{ localizacaoUsuario }}
      .descricao(v-if="biografiaUsuario") {{ biografiaUsuario }}
    .card-podium
      .top-3(
        v-for="(podium, idx) in podiumHabilidades"
        :key="podium.skill"
        v-if="podiumHabilidades.length > 0"
      )
        .trofeu
          LucideIcon(name="Trophy" :size="16" :color="podium.filledColor")
        Estrelas(
          :filled="podium.filled"
          :filledColor="podium.filledColor"
          :size="estrelasSize"
          useStroke
        )
        .habilidade {{ podium.skill }}
        .posicao {{ podium.posicao }}º Lugar
      .mensagem-vazia(v-if="podiumHabilidades.length === 0")
        LucideIcon(name="Trophy" :size="32" color="#4b5563")
        p Nenhuma habilidade top 3 cadastrada
        small 
          | Acesse 
          span.link(@click="$router.push('/espaco-nexa/editar-perfil/top-habilidades')") Editar Perfil > Top Habilidades
          |  para adicionar
  .habilidades
    .label-habilidades
      LucideIcon(name="Star" :size="16" color="#b7ff00")
      | Habilidades
    template(v-if="habilidades.length > 0")
      BarraHabilidades(
        v-for="(hab, idx) in habilidades"
        :key="hab.skill"
        :skill="hab.skill"
        :level="hab.level"
      )
    .mensagem-vazia(v-else)
      LucideIcon(name="Star" :size="32" color="#4b5563")
      p Nenhuma habilidade cadastrada
      small 
        | Acesse 
        span.link(@click="$router.push('/espaco-nexa/editar-perfil/outras-habilidades')") Editar Perfil > Todas Habilidades
        |  para adicionar
  .btn-feedback(
    @click="handleFeedbackClick"
    title="Enviar Feedback"
  )
    LucideIcon(name="MessageSquare" :size="18")
    span Enviar Feedback
  FeedbackModal(:visible="feedbackModalVisible" @close="closeFeedbackModal")
</template>

<script>
import { mapGetters } from 'vuex'
import Tags from '@/components/ui/Tags.vue'
import BarraHabilidades from '@/components/ui/BarraHabilidades.vue'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import Estrelas from '@/components/ui/Stars.vue'
import FeedbackModal from '@/components/ui/FeedbackModal.vue'

export default {
  name: 'Perfil',
  components: {
    Tags,
    BarraHabilidades,
    ButtonPadrao,
    Estrelas,
    FeedbackModal
  },
  data() {
    return {
      fotoPerfil: require('@/assets/placeholder.svg'),
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
      feedbackModalVisible: false
    }
  },
  computed: {
    ...mapGetters({
      podiumHabilidades: 'perfil/podiumHabilidades',
      tags: 'perfil/tagsHabilidades',
      currentUser: 'auth/getUser'
    }),
    
    habilidades() {
      const habilidadesOriginais = this.$store.getters['perfil/listaHabilidades']
      
      // Define a ordem dos níveis (do maior para o menor)
      const ordemNiveis = {
        'Mestre': 6,
        'Professor': 5,
        'Profissional': 4,
        'Praticante': 3,
        'Aprendiz': 2,
        'Iniciando': 1
      }
      
      // Ordena as habilidades por nível
      return [...habilidadesOriginais].sort((a, b) => {
        const nivelA = ordemNiveis[a.level] || 0
        const nivelB = ordemNiveis[b.level] || 0
        return nivelB - nivelA
      })
    },
    
    estrelasSize() {
      return this.windowWidth <= 390 ? 14 : 16
    },
    
    nomeUsuario() {
      const userData = this.$store.state.auth.user
      if (!userData) return 'Carregando...'
      if (typeof userData === 'string') return 'Erro: JSON detectado'
      if (userData.id && !userData.nome && !userData.usuario) return 'Carregando...'
      
      // Tenta pegar nome, se não existir ou estiver vazio usa "Nome do Desenvolvedor"
      return (userData.nome && userData.nome.trim() !== '') ? userData.nome : 'Nome do Desenvolvedor'
    },
    
    usuarioApelido() {
      const userData = this.$store.state.auth.user
      if (!userData) return '@carregando'
      if (typeof userData === 'string') return '@erro'
      if (userData.id && !userData.usuario && !userData.email) return '@carregando'
      
      // Retorna o usuario exatamente como vem da API
      return userData.usuario || userData.email || 'usuario'
    },
    
    funcaoUsuario() {
      const userData = this.$store.state.auth.user
      if (!userData) return ''
      return userData.funcao || ''
    },
    
    localizacaoUsuario() {
      const userData = this.$store.state.auth.user
      if (!userData) return ''
      
      const partes = []
      if (userData.cidade) partes.push(userData.cidade)
      if (userData.uf) partes.push(userData.uf)
      
      return partes.join(', ')
    },
    
    biografiaUsuario() {
      const userData = this.$store.state.auth.user
      if (!userData) return ''
      return userData.biografia || ''
    },
    
    fotoPerfilUsuario() {
      const userData = this.$store.state.auth.user
      if (!userData || !userData.foto_perfil) {
        return require('@/assets/placeholder.svg')
      }
      
      // Garante que a foto tem o prefixo data URI correto
      const foto = userData.foto_perfil
      if (foto.startsWith('data:image')) {
        return foto
      } else {
        // Adiciona o prefixo se não existir
        return `data:image/jpeg;base64,${foto}`
      }
    }
  },
  watch: {
    fotoPerfilUsuario: {
      handler(newFoto) {
        this.fotoPerfil = newFoto
      },
      immediate: true
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.updateWindowWidth)
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWindowWidth)
    }
  },
  methods: {
    selecionarFoto() {
      if (this.$refs.inputFoto) this.$refs.inputFoto.click()
    },
    onFotoSelecionada(event) {
      const file = event.target.files && event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.fotoPerfil = e.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
    handleFeedbackClick() {
      this.feedbackModalVisible = true
    },
    showFeedbackModal() {
      this.feedbackModalVisible = true
    },
    closeFeedbackModal() {
      this.feedbackModalVisible = false
    }
  }
}
</script>

<style lang="scss">
.container-perfil {
  width: 100%;
  border: 1px solid $borderColor;
  border-radius: 8px;
  background-color: $corFundoPadraoDashboard;
  margin-top: 190px;
  transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), box-shadow 0.25s cubic-bezier(0.4,0,0.2,1);
  position: relative;

  &::after {
    content: "";
    display: table;
    clear: both;
  }

  &:hover {
    transform: scale(1.006);
    box-shadow: 0 5px 10px 0 #b7ff0033;
  }

  &.modal-open {
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }

  .btn-feedback {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 20px 25px 25px 25px;
    padding: 10px 16px;
    cursor: pointer;
    border-radius: 8px;
    background: $corPreto;
    border: 1px solid $borderColor;
    color: $corValueInfoContato;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    float: right;
    clear: both;

    &:hover {
      background: $corVerdeClaroHover;
      color: $corVerdeClaro;
      border-color: $corVerdeClaro;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(183, 255, 0, 0.2);
    }

    &:active {
      transform: translateY(0);
    }

    svg {
      flex-shrink: 0;
    }
  }

  .header {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 0 25px;
    box-sizing: border-box;

    .info-desenvolvedor {
      display: flex;
      flex-direction: column;
      padding: 25px 0;

      .pessoa {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 10px;

        .foto-perfil {
          width: 80px;
          height: 80px;
          min-width: 80px;
          min-height: 80px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid $corVerdeClaro;
          box-sizing: border-box;
          position: relative;
          z-index: 0;
          aspect-ratio: 1/1;
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }

          &::after {
            content: "";
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0,0,0,0.45);
            opacity: 0;
            transition: opacity 0.2s;
            z-index: 3;
            border-radius: 50%;
            pointer-events: none;
          }
          
          &:hover{
            color: $corVerdeClaro;  
            &::after {
              opacity: 1;
            }

            .icone-camera{
              opacity: 1;
            }
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-width: 0;

          .nome {
            font-size: 20px;
            font-weight: bold;
            color: $corVerdeClaro;
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 5px;
            width: 100%;
            min-width: 0;

            // Container do texto com ellipsis
            > span {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              flex-shrink: 1;
            }

            .editar-perfil{
              width: 24px;
              height: 24px;
              min-width: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              border-radius: 100%;
              color: $corBranco;
              flex-shrink: 0;

              &:hover {
                background: $corVerdeClaroHover;
                color: $corVerdeClaro;
              }
            }
          }

          .funcao, .localizacao, .usuario {
            font-size: 14px;
            color: $corValueInfoContato;
            display: flex;
            align-items: center;
            gap: 5px;
            margin-top: 5px;
          }
        }
      }

      .descricao {
        font-size: 14px;
        color: $corValueInfoContato;
      }
    }

    .card-podium{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      max-width: 800px;
      width: 100%;
      margin: 0 auto;

      .top-3 {
        padding: 15px 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: $corPreto;
        border-radius: 8px;
        position: relative;
        border: 1px solid $borderColor;
        box-sizing: border-box;

        .trofeu {
          position: absolute;
          top: -8px;
          right: -7px;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: $corFundoPadraoDashboard;
          border-radius: 100%;
          border: 2px solid $borderColor;
          box-sizing: border-box;
          z-index: 1;
        }

        &:hover{
          border-color: $corVerdeClaro;

          .trofeu {
            border-color: $corVerdeClaro;
          }
        }
  
        .habilidade {
          font-size: 14px;
          font-weight: 500;
          color: $corBranco;
          margin: 10px 0 6px 0;
        }
  
        .posicao {
          font-size: 12px;
          color: $corValueInfoContato;
        }
      }

      .mensagem-vazia {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        text-align: center;
        color: $corValueInfoContato;
        width: 100%;

        svg {
          margin-bottom: 12px;
          opacity: 0.5;
        }

        p {
          font-size: 14px;
          font-weight: 500;
          margin: 0 0 8px 0;
        }

        small {
          font-size: 12px;
          opacity: 0.7;

          .link {
            color: $corVerdeClaro;
            cursor: pointer;
            text-decoration: underline;
            transition: opacity 0.2s;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }

  .habilidades {
    margin-bottom: 25px;
    padding: 0 25px;
    box-sizing: border-box;

    .label-habilidades {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: $corVerdeClaro;
      font-size: 16px;
      font-weight: 600;

      svg {
        margin-right: 5px;
      }
    }

    .mensagem-vazia {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 20px;
      text-align: center;
      color: $corValueInfoContato;
      border: 1px dashed $borderColor;
      border-radius: 8px;
      background: $corPreto;

      svg {
        margin-bottom: 12px;
        opacity: 0.5;
      }

      p {
        font-size: 14px;
        font-weight: 500;
        margin: 0 0 8px 0;
      }

      small {
        font-size: 12px;
        opacity: 0.7;

        .link {
          color: $corVerdeClaro;
          cursor: pointer;
          text-decoration: underline;
          transition: opacity 0.2s;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .container-perfil {
    margin-top: 110px;

    .btn-feedback {
      margin: 15px 15px 20px 15px;
      padding: 8px 12px;
      font-size: 13px;

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .header {
      .info-desenvolvedor {
        .pessoa {
          .info {
            .nome {
              font-size: 16px;
            }
          }
        }
        .descricao {
          text-align: justify;
        }
      }
      .card-podium {
        gap: 10px;
      }
    }

    .habilidades {
      margin-bottom: 30px;
    }
  }
}

@media (max-width: 390px) {
  .container-perfil {
    .header {
      .card-podium {
        gap: 10px;
        .top-3 {
          padding: 15px 10px;
          min-width: 100px;

          .trofeu{
            top: -12px
          }
          .habilidade {
            font-size: 12px;
          }
          .posicao {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>